import { errorInterceptorHandler } from '../../utils';
import { FetchResponse } from '../fetch.model';
import { createApiError } from './api-error.util';
import { isStreamingContentType } from './streaming.util';

export const handleResponse = async <T>(
  response: Response,
  url: string,
): Promise<FetchResponse<T>> => {
  const contentType = response.headers.get('content-type');
  const isStreamingResponse = isStreamingContentType(contentType);

  if (!response.ok) {
    let responseData: unknown = null;

    if (!isStreamingResponse) {
      try {
        responseData = await response.clone().json();
      } catch {
        // Response body is not JSON, keep null
      }
    }

    const error = createApiError({
      message: `Request failed with status ${response.status}`,
      response,
      url,
    });

    if (error.response) {
      error.response.data = responseData;
    }

    await errorInterceptorHandler(error);

    throw error;
  }

  if (response.status === 204 || response.status === 205) {
    return { data: undefined as unknown as T };
  }

  if (
    contentType?.includes('application/pdf') ||
    contentType?.includes('application/octet-stream')
  ) {
    return { data: (await response.blob()) as T };
  }

  let data: T;

  try {
    data = await response.json();
  } catch (error) {
    const apiError = createApiError({
      message: `Failed to parse JSON response from ${url}`,
      originalError: error as Error,
      response,
      url,
    });

    await errorInterceptorHandler(apiError);

    throw apiError;
  }

  return { data };
};
